<mat-card appearance="outlined">
  <div class="section-title">
    {{ title }}
  </div>

  <div class="section-description">
    {{ description }}
  </div>

  <div *ngIf="userRoles">
    <div class="tw-flex tw-gap-2 tw-mb-4">
      <ui-svg-icon class="tw-align-middle" [name]="iconNameList.AlertInfo"></ui-svg-icon>
      <div>{{ 'administration.user.item.hubList.userRolesNote.part1' | translate }}</div>
    </div>
    <div class="tw-mb-4">
      <strong>{{ 'administration.user.item.hubList.userRolesNote.part2' | translate }}: </strong>
      {{ userRoles }}
    </div>
  </div>
  <hr size="1" />
  <div *ngIf="hubList?.length">
    <div class="hubs-title">{{ 'common.field.assignedHubs' | translate }}</div>
    <mat-chip-listbox>
      <mat-chip-option
        *ngFor="let partner of hubList"
        [selectable]="false"
        [removable]="isDataEditable"
        (removed)="removeHub(partner)"
      >
        {{ partner.name }}
        <ui-svg-icon [name]="iconNameList.Close" [width]="18" matChipRemove></ui-svg-icon>
      </mat-chip-option>
    </mat-chip-listbox>
  </div>
  <div *ngIf="isDataEditable" class="tw-mt-8 link" (click)="manageHubs()">
    <ui-svg-icon class="tw-align-middle" [name]="iconNameList.Add"></ui-svg-icon>

    <span class="tw-align-middle"> {{ 'containerComponents.hubSelection.addHub' | translate }}</span>
  </div>
</mat-card>
